import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingDefault from '../../components/LoadingDefault';
import { fetchUserSigninCallback } from '../../helper/actions/fetchActions/fetchAuth';

export const SigninRedirect = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading } = useSelector(store => store.loading);
 
  useEffect(() => {
    dispatch(fetchUserSigninCallback(history.push));
  },[dispatch, history]);

  return (
    <>
      {loading && <LoadingDefault typeLoading="card" />}
    </>
  );
};

export default SigninRedirect;
